import {Divider, Image, Layout, Typography} from 'antd';
import React from 'react';
import appColors from '../../../style/theme';

const {Text, Paragraph} = Typography;
const Content = Layout;

const Seis = () => {
  return (
    <Layout style={{margin: '0 5.2vh 5.2vh 5.2vh', background: 'transparent'}}>
      <Content style={{background: 'inherit'}}>
        <Paragraph className= 'Title3T' style={{color: appColors['ColorX'], marginTop: '3%'}}>Value Proposition</Paragraph>
        <Text className='BaseText2'>The market for our diagnostic test includes private and public health care facilitie in Mexico. iMoAge creates value for these customers through the following aspects:</Text>
        <Content style={{marginLeft: 'auto', marginRight: 'auto', maxWidth: '80%', background: 'inherit', marginTop: '2%'}}>
          <Image src='https://static.igem.wiki/teams/4464/wiki/emprendimiento/imagen-22.png'/>
          <p> <b>Fig. 5.</b> iMoAge&apos;s Value Proposition Canvas. 6 main aspects were analyzed in our product that will help us enter the market and target our customers easier.</p>
        </Content>
      </Content>
      <Divider/>
    </Layout>
  );
};

export default Seis;
